export class BigQueryNativePitrBackupResourceType {
    'resourceType';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceType & string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BigQueryNativePitrBackupResourceType.attributeTypeMap;
    }
    constructor() {
    }
}
